import React from 'react'
import styles from './GetAge.css'
import moment from 'moment'

export const GetAge = props => {
  const {
    dob,
    onlyAge = false // true will returns only number of years
  } = props

  const getAge = date => {
    if (date) {
      return moment().diff(moment(date), 'years')
    } else {
      return '-'
    }
  }

  return (
    <span>{getAge(dob)} {!onlyAge && 'yrs old'}</span>
  )
}

export default GetAge



// WEBPACK FOOTER //
// ./src/legacy/components/GetAge/GetAge.jsx